import { render, staticRenderFns } from "./oyster.vue?vue&type=template&id=3dedc73e&"
import script from "./oyster.vue?vue&type=script&lang=js&"
export * from "./oyster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports